import { render, staticRenderFns } from "./KabupatenV2.vue?vue&type=template&id=0c3ea889"
import script from "./KabupatenV2.vue?vue&type=script&lang=js"
export * from "./KabupatenV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports